export const GET_BUSINESS_EMAIL_TEMPLATES = "GET_BUSINESS_EMAIL_TEMPLATES";
export const GET_BUSINESS_EMAIL_TEMPLATES_SUCCESS = "GET_BUSINESS_EMAIL_TEMPLATES_SUCCESS";
export const GET_BUSINESS_EMAIL_TEMPLATES_FAIL = "GET_BUSINESS_EMAIL_TEMPLATES_FAIL";
export const RESET_LIST_BUSINESS_EMAIL_TEMPLATES = "RESET_LIST_BUSINESS_EMAIL_TEMPLATES";

export const GET_BUSINESS_EMAIL_TEMPLATE_DETAILS = "GET_BUSINESS_EMAIL_TEMPLATE_DETAILS";
export const GET_BUSINESS_EMAIL_TEMPLATE_DETAILS_SUCCESS = "GET_BUSINESS_EMAIL_TEMPLATE_DETAILS_SUCCESS";
export const GET_BUSINESS_EMAIL_TEMPLATE_DETAILS_FAIL = "GET_BUSINESS_EMAIL_TEMPLATE_DETAILS_FAIL";

export const CREATE_BUSINESS_EMAIL_TEMPLATE = "CREATE_BUSINESS_EMAIL_TEMPLATE";
export const CREATE_BUSINESS_EMAIL_TEMPLATE_SUCCESS = "CREATE_BUSINESS_EMAIL_TEMPLATE_SUCCESS";
export const CREATE_BUSINESS_EMAIL_TEMPLATE_FAIL = "CREATE_BUSINESS_EMAIL_TEMPLATE_FAIL";

export const UPDATE_BUSINESS_EMAIL_TEMPLATE = "UPDATE_BUSINESS_EMAIL_TEMPLATE";
export const UPDATE_BUSINESS_EMAIL_TEMPLATE_SUCCESS = "UPDATE_BUSINESS_EMAIL_TEMPLATE_SUCCESS";
export const UPDATE_BUSINESS_EMAIL_TEMPLATE_FAIL = "UPDATE_BUSINESS_EMAIL_TEMPLATE_FAIL";

export const DELETE_BUSINESS_EMAIL_TEMPLATE = "DELETE_BUSINESS_EMAIL_TEMPLATE";
export const DELETE_BUSINESS_EMAIL_TEMPLATE_SUCCESS = "DELETE_BUSINESS_EMAIL_TEMPLATE_SUCCESS";
export const DELETE_BUSINESS_EMAIL_TEMPLATE_FAIL = "DELETE_BUSINESS_EMAIL_TEMPLATE_FAIL";
